import BreederPostModal from 'dpl/breeder_posts/components/BreederPostModal';
import ParentModal from 'dpl/dog_modals/parent_modal/components/ParentModal';
import Layout from 'dpl/puppy_page/components/Layout';
import initReactApp from 'dpl/util/initReactApp';

initReactApp({
  Layout,
  ParentModal,
  BreederPostModal
});
